// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3R11Q","colMaxWidth":"Table_colMaxWidth__3yoKj"};